import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import { SearchFilters } from '@@/bits/web_search'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import { useContentPickerStore } from '@@/pinia/content_picker'
import { processedUrl } from '@padlet/vivaldi-client'


export default /*#__PURE__*/_defineComponent({
  __name: 'AiImageSearchSample',
  emits: ["run-sample-search"],
  setup(__props, { emit }: { emit: ({
  (name: 'run-sample-search', payload: { searchQuery: string }): void
}), expose: any, slots: any, attrs: any }) {



const AI_SEARCH_SAMPLE =
  'An expressive oil painting of a basketball player dunking, as depicted as an explosion of a nebula'

const { setSearchQuery, search, pickSearchFilter } = useContentPickerStore()

const searchForSample = (): void => {
  setSearchQuery({ query: AI_SEARCH_SAMPLE })
  pickSearchFilter({ filter: SearchFilters.AiImages })
  search()
  emit('run-sample-search', { searchQuery: AI_SEARCH_SAMPLE })
}

return { __sfc: true,emit, AI_SEARCH_SAMPLE, setSearchQuery, search, pickSearchFilter, searchForSample, __, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, processedUrl }
}

})